module.exports = __webpack_public_path__ + "static/media/taxi-mobile.937e2fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/taxi-mobile.png
// module id = 252
// module chunks = 0